import React, { useEffect, useState } from "react";
import NoDataFound from "../../../Extra/NoDataFound";

const SevenAMonthwiseReport = ({ data, status, from, targetData }) => {
  // console.log({ data }, { status }, { from }, { targetData });
  const [tableHead, setTableHead] = useState(null);
  const [target, setTarget] = useState(null);
  useEffect(() => {
    if (status.years.length > 0) {
      let objHead = Object.entries(data?.series[0]).map(([key, value], o) => {
        return key;
      });
      objHead.splice(0, 1);
      setTableHead(objHead);
      const a = getSummary(targetData, status);
      setTarget(a);
    } else setTableHead([]);
  }, [data, status]);
  function getSummary(data, status) {
    // Initialize summary object with years and commodities
    const summary = {};

    status.years.forEach((year) => {
      summary[year] = {};

      status.Commodity.forEach((comm) => {
        summary[year][comm] = { tgt_ch: 0, tgt_wgn: 0 };
      });
    });

    // Process each data row
    data.forEach((row) => {
      const { commodity, f_year, month, tgt_ch, tgt_wgn } = row;

      if (
        status.years.includes(f_year) &&
        status.Commodity.includes(commodity) &&
        status.months.includes(month)
      ) {
        summary[f_year][commodity].tgt_ch += Number(tgt_ch);
        summary[f_year][commodity].tgt_wgn += Number(tgt_wgn);
      }
    });

    return summary;
  }
  const headWithTarget =
    tableHead && tableHead.find((str) => str.includes("target"));
  const cleanedTargetYear =
    headWithTarget && headWithTarget
      ? headWithTarget.replace("_target", "")
      : null;
  const keyname = from === "chWight" ? "tgt_ch" : "tgt_wgn";
  return (
    <div>
      {status.Commodity.length > 0 && tableHead && tableHead.length > 0 ? (
        <div>
          <div className="row d-flex align-items-centre p-1 bg-dark text-white">
            <h5>7A Month wise Report</h5>
          </div>
          <div className="table-responsive">
            <table
              className="table newUiTable table-striped table-hover"
              style={{ fontSize: "11.5px", fontWeight: "bold" }}
            >
              <thead>
                <tr className="table-dark2 ">
                  <th>Sno</th>
                  <th>Commodity</th>
                  {tableHead.map((head, i) => (
                    <th key={i}>{head.replace(/_/g, " ")}</th>
                  ))}
                </tr>
              </thead>

              {data &&
              target &&
              cleanedTargetYear &&
              data?.series?.length > 0 ? (
                <React.Fragment>
                  <tbody>
                    {target[cleanedTargetYear] &&
                      Object.keys(target[cleanedTargetYear])?.length > 0 &&
                      data.series.map((obj, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{obj.product}</td>
                          {target &&
                            tableHead?.map((head, j) => (
                              <td key={j}>
                                {headWithTarget === head
                                  ? target[cleanedTargetYear][obj.product][
                                      keyname
                                    ]
                                  : obj[head]}
                              </td>
                            ))}
                        </tr>
                      ))}
                  </tbody>
                  <tfoot>
                    <tr className="table-secondary fw-bold">
                      <td colSpan={2}>Total</td>
                      {tableHead.map((head, i) => {
                        const total = data.series.reduce(
                          (sum, row) => sum + (Number(row[head]) || 0),
                          0
                        );

                        return (
                          <td key={i}>
                            {i === 0 || i === 2
                              ? from === "chWight"
                                ? `${(total / 1000000).toFixed(2)}M`
                                : `${(total / 1000).toFixed(2)}K`
                              : from === "chWight"
                              ? `${(
                                  target[cleanedTargetYear] &&
                                  Object.values(
                                    target[cleanedTargetYear]
                                  )?.reduce(
                                    (sum, item) => sum + item[keyname],
                                    0
                                  ) / 1000000
                                )?.toFixed(2)}M`
                              : `${(
                                  target[cleanedTargetYear] &&
                                  Object.values(
                                    target[cleanedTargetYear]
                                  )?.reduce(
                                    (sum, item) => sum + item[keyname],
                                    0
                                  ) / 1000
                                )?.toFixed(2)}K`}
                          </td>
                        );
                      })}
                    </tr>
                  </tfoot>
                </React.Fragment>
              ) : (
                "No Data Found"
              )}
            </table>
          </div>
        </div>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default SevenAMonthwiseReport;
